import {Component, EventEmitter, Input, Output} from "@angular/core";
import {Country, Order} from "../../../store/state/order.state";
import {ChangeSet} from "../history/order-history.model";
import {Observable} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {map} from "rxjs/operators";
import {NotificationService} from "../../../umbrella-common/services/notification.service";

@Component({
    selector: 'billing-information',
    templateUrl: './billing-information.template.html',
    styleUrls: ['./billing-information.style.scss'],
    standalone: false
})
export class BillingInformationComponent {

	@Input() order: Order;
	@Input() detailsVisible: boolean = false;
	@Input() collapsable: boolean = true;
	@Input() editable = true;
	@Input() showDekraInfo = true;
	@Input() multipleAppearance = false;
	@Input() changeSet: ChangeSet;

	@Output() changeRequested: EventEmitter<any> = new EventEmitter<any>();
	@Output() changeCanceled: EventEmitter<any> = new EventEmitter<any>();
	@Output() changeApproved: EventEmitter<any> = new EventEmitter<any>();

	editMode = false;
	countries$: Observable<Country[]>;

	constructor(private route: ActivatedRoute, private notifications: NotificationService) {
	}

	ngOnInit() {
		this.countries$ = this.route.data.pipe(map(data => data['countries'] as Country[]));
	}

	openEditMode() {
		this.editMode = true;
		this.changeRequested.emit();
	}

	onChangesSaved(correlationId: string) {
		this.editMode = false;
		this.detailsVisible = false;
		this.changeApproved.emit(correlationId);
		this.notifications.success({textKey: 'order-edit.notifications.success'});
	}

	onChangesCanceled() {
		this.editMode = false;
		this.detailsVisible = false;
		this.changeCanceled.emit();
	}
}
